/**
 * Google Analytics 4 utility functions
 */

declare global {
	interface Window {
		dataLayer: any[]
		gtag: (...args: any[]) => void
	}
}

/**
 * Tracks a page view in Google Analytics
 */
export function pageView(url: string) {
	if (!window.gtag || !window.ENV.GA_MEASUREMENT_ID) return

	window.gtag('config', window.ENV.GA_MEASUREMENT_ID as string, {
		page_path: url,
	})
}

/**
 * Tracks a custom event in Google Analytics
 */
export function event(action: string, params: Record<string, any> = {}) {
	if (!window.gtag || !window.ENV.GA_MEASUREMENT_ID) return

	window.gtag('event', action, params)
}
